// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"7678dd2a304426636fc2","731":"73a7c461f06882728efa","843":"df9fe09d8c398c9dd968","883":"85bcd93b8a6bcfa61dee"}[chunkId] + ".js";
};